module.exports = __webpack_public_path__ + "static/media/1f5e8.dc9bee11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/1f5e8.svg
// module id = 634
// module chunks = 1